function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
var useDeviceDetect = function useDeviceDetect() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasTouchScreen = _useState2[0],
    setHasTouchScreen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isIOS = _useState4[0],
    setIsIOS = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAndroid = _useState6[0],
    setIsAndroid = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isWindows = _useState8[0],
    setIsWindows = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isMacOS = _useState10[0],
    setIsMacOS = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isChromeBrowser = _useState12[0],
    setIsChomeBrowser = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isFirefoxBrowser = _useState14[0],
    setIsFirefoxBrowser = _useState14[1];
  useEffect(function () {
    var UA = navigator.userAgent;
    var userPlatform = navigator.platform;

    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Device_Detection
    if ("maxTouchPoints" in navigator) {
      setHasTouchScreen(navigator.maxTouchPoints > 0);
    } else if ("msMaxTouchPoints" in navigator) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setHasTouchScreen(navigator.msMaxTouchPoints > 0);
    } else {
      var mQ = matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        setHasTouchScreen(mQ.matches);
      } else if ("orientation" in window) {
        setHasTouchScreen(true); // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        setHasTouchScreen(/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA));
      }
    }

    // https://stackoverflow.com/a/9039885
    setIsIOS(["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    UA.includes("Mac") && "ontouchend" in document);

    // https://stackoverflow.com/a/6031480/3655664
    setIsAndroid(UA.toLowerCase().indexOf("android") > -1);
    setIsWindows(userPlatform.toLowerCase().indexOf("win") > -1);

    // MacOS detection
    setIsMacOS(navigator.platform.includes("Mac") || UA.includes("Macintosh") || navigator.vendor.includes("Apple Inc.") || UA.includes("Safari") && UA.includes("intosh"));
    setIsChomeBrowser(UA.toLowerCase().indexOf("chrome") > -1);
    setIsFirefoxBrowser(UA.toLowerCase().indexOf("firefox") > -1);
  }, []);
  return {
    isDesktop: !hasTouchScreen,
    isMobile: hasTouchScreen,
    isIOS: isIOS,
    isAndroid: isAndroid,
    isWindows: isWindows,
    isMacOS: isMacOS,
    isAppleDevice: isIOS || isMacOS,
    isChromeBrowser: isChromeBrowser,
    isFirefoxBrowser: isFirefoxBrowser
  };
};
export default useDeviceDetect;